/**
 * Category Navigation Mega Menu JavaScript
 * Updated: Auto-selects first item by default
 */

class CategoryNavigation {
  constructor() {
    this.megaMenuItems = document.querySelectorAll('.category-navigation__item--has-dropdown');
    this.categoryLinks = document.querySelectorAll('.category-navigation__mega-menu-category-link');
    this.categoryPanels = document.querySelectorAll('.category-navigation__mega-menu-panel');
    
    this.mobileToggle = document.querySelector('[data-category-mobile-toggle]') || document.querySelector('.header__icon--menu');
    this.mobileOverlay = document.querySelector('[data-category-mobile-overlay]');
    this.mobileClose = document.querySelector('[data-category-mobile-close]');
    this.mobileContent = document.querySelector('.category-navigation__mobile-content');
    this.navElement = document.querySelector('.category-navigation__nav');
    
    this.isMobileMenuOpen = false;
    
    if(this.navElement && !this.navElement.dataset.initialized) {
        this.init();
        this.navElement.dataset.initialized = "true";
    }
  }

  init() {
    this.bindEvents();
    this.initMobileMenu();
    this.setDefaults();
  }

  setDefaults() {
    this.megaMenuItems.forEach(item => {
      const firstLink = item.querySelector('.category-navigation__mega-menu-category-link');
      if (firstLink) {
        firstLink.classList.add('active');
        const handle = firstLink.getAttribute('data-category');
        const panel = item.querySelector(`[data-category-panel="${handle}"]`);
        if (panel) panel.style.display = 'block';
      }
    });
  }

  bindEvents() {
    this.categoryLinks.forEach(link => {
      link.addEventListener('mouseenter', () => {
        const parentMenu = link.closest('.category-navigation__mega-menu');
        this.switchCategory(link.dataset.category || '', parentMenu);
      });
      link.addEventListener('click', (e) => {
        if(link.getAttribute('href') === '#') e.preventDefault();
        const parentMenu = link.closest('.category-navigation__mega-menu');
        this.switchCategory(link.dataset.category || '', parentMenu);
      });
    });

    this.megaMenuItems.forEach(item => {
      const megaMenu = item.querySelector('.category-navigation__mega-menu');
      if (megaMenu) {
        item.addEventListener('mouseenter', () => this.cancelClose());
        item.addEventListener('mouseleave', () => this.scheduleClose());
      }
    });
  }

  switchCategory(categoryHandle, parentMenu) {
    if (!parentMenu) return;
    const links = parentMenu.querySelectorAll('.category-navigation__mega-menu-category-link');
    links.forEach(link => {
      if(link.dataset.category === categoryHandle) {
         link.classList.add('active');
      } else {
         link.classList.remove('active');
      }
    });
    const panels = parentMenu.querySelectorAll('.category-navigation__mega-menu-panel');
    panels.forEach(panel => {
      if (panel.dataset.categoryPanel === categoryHandle) {
        panel.style.display = 'block';
      } else {
        panel.style.display = 'none';
      }
    });
  }

  cancelClose() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  scheduleClose() {
    this.closeTimeout = setTimeout(() => {}, 300);
  }

  initMobileMenu() {
    if (!this.mobileToggle || !this.mobileOverlay) return;
    this.bindMobileEvents();
    this.populateMobileMenu();
  }

  bindMobileEvents() {
    this.mobileToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation(); 
      this.toggleMobileMenu();
    });

    if (this.mobileClose) this.mobileClose.addEventListener('click', () => this.closeMobileMenu());
    if (this.mobileOverlay) this.mobileOverlay.addEventListener('click', (e) => {
        if (e.target === this.mobileOverlay) this.closeMobileMenu();
    });
  }

  populateMobileMenu() {
    if (!this.mobileContent || !this.navElement) return;
    this.mobileContent.innerHTML = '';
    const navClone = this.navElement.cloneNode(true);
    this.simplifyMobileStructure(navClone);
    this.mobileContent.appendChild(navClone);
    this.bindMobileDropdownEvents(navClone);
  }

  simplifyMobileStructure(navElement) {
    const megaMenus = navElement.querySelectorAll('.category-navigation__mega-menu');
    megaMenus.forEach(megaMenu => {
      const categoryLinks = megaMenu.querySelectorAll('.category-navigation__mega-menu-category-link');
      if (categoryLinks.length > 0) {
        const accordionList = document.createElement('ul');
        accordionList.className = 'category-navigation__mobile-accordion-list';
        
        categoryLinks.forEach(link => {
          const listItem = document.createElement('li');
          listItem.className = 'category-navigation__mobile-accordion-item';
          
          const subcategoryHeader = document.createElement('button');
          subcategoryHeader.className = 'category-navigation__mobile-accordion-header';
          subcategoryHeader.setAttribute('aria-expanded', 'false');
          subcategoryHeader.innerHTML = `<span class="category-navigation__mobile-accordion-title">${link.textContent}</span><svg class="category-navigation__mobile-accordion-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
          
          const submenuContainer = document.createElement('div');
          submenuContainer.className = 'category-navigation__mobile-accordion-content';
          
          const categoryHandle = link.getAttribute('data-category');
          const rightPanel = megaMenu.querySelector(`[data-category-panel="${categoryHandle}"]`);
          
          if (rightPanel) {
            const nestedItems = rightPanel.querySelectorAll('a');
            if (nestedItems.length > 0) {
              const nestedList = document.createElement('ul');
              nestedList.className = 'category-navigation__mobile-nested-list';
              nestedItems.forEach(nestedItem => {
                const linkText = nestedItem.textContent.trim();
                if (linkText) {
                  const nestedListItem = document.createElement('li');
                  nestedListItem.className = 'category-navigation__mobile-nested-item';
                  const nestedLink = document.createElement('a');
                  nestedLink.href = nestedItem.href;
                  nestedLink.className = 'category-navigation__mobile-nested-link';
                  nestedLink.textContent = linkText;
                  nestedListItem.appendChild(nestedLink);
                  nestedList.appendChild(nestedListItem);
                }
              });
              submenuContainer.appendChild(nestedList);
            }
          } else {
             const directLink = document.createElement('a');
             directLink.href = link.href;
             directLink.className = 'category-navigation__mobile-direct-link';
             directLink.textContent = link.textContent.trim();
             submenuContainer.appendChild(directLink);
          }
          listItem.appendChild(subcategoryHeader);
          listItem.appendChild(submenuContainer);
          accordionList.appendChild(listItem);
        });
        megaMenu.innerHTML = '';
        megaMenu.appendChild(accordionList);
        megaMenu.classList.add('category-navigation__mobile-nested-accordion');
      }
    });
  }

  bindMobileDropdownEvents(navElement) {
    const dropdownItems = navElement.querySelectorAll('.category-navigation__item--has-dropdown');
    dropdownItems.forEach((item) => {
      const link = item.querySelector('.category-navigation__link');
      const megaMenu = item.querySelector('.category-navigation__mega-menu');
      if (link && megaMenu) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleMobileDropdown(item, megaMenu);
        });
      }
    });

    const accordionHeaders = navElement.querySelectorAll('.category-navigation__mobile-accordion-header');
    accordionHeaders.forEach((header) => {
      header.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleNestedAccordion(header);
      });
    });
  }

  toggleMobileDropdown(item, megaMenu) {
    const isActive = megaMenu.classList.contains('active');
    const allDropdowns = this.mobileContent.querySelectorAll('.category-navigation__mega-menu.active');
    allDropdowns.forEach(d => {
        if(d !== megaMenu) {
            d.classList.remove('active');
            d.style.maxHeight = '0px';
        }
    });
    if (!isActive) {
      megaMenu.classList.add('active');
      megaMenu.style.maxHeight = megaMenu.scrollHeight + 'px';
      setTimeout(() => { if(megaMenu.classList.contains('active')) megaMenu.style.maxHeight = 'none'; }, 300);
    } else {
      megaMenu.classList.remove('active');
      megaMenu.style.maxHeight = '0px';
    }
  }

  toggleNestedAccordion(header) {
    const content = header.nextElementSibling;
    const arrow = header.querySelector('.category-navigation__mobile-accordion-arrow');
    const isExpanded = header.getAttribute('aria-expanded') === 'true';
    const parentList = header.closest('ul');
    if(parentList) {
        const peerHeaders = parentList.querySelectorAll('.category-navigation__mobile-accordion-header');
        peerHeaders.forEach(ph => {
            if(ph !== header) {
                ph.setAttribute('aria-expanded', 'false');
                ph.nextElementSibling.style.maxHeight = '0px';
                ph.nextElementSibling.classList.remove('active');
                const phArrow = ph.querySelector('.category-navigation__mobile-accordion-arrow');
                if(phArrow) phArrow.style.transform = 'rotate(0deg)';
            }
        });
    }
    if (!isExpanded) {
      header.setAttribute('aria-expanded', 'true');
      content.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
      if (arrow) arrow.style.transform = 'rotate(180deg)';
    } else {
      header.setAttribute('aria-expanded', 'false');
      content.classList.remove('active');
      content.style.maxHeight = '0px';
      if (arrow) arrow.style.transform = 'rotate(0deg)';
    }
  }

  toggleMobileMenu() {
    if (this.isMobileMenuOpen) this.closeMobileMenu(); else this.openMobileMenu();
  }

  openMobileMenu() {
    this.isMobileMenuOpen = true;
    this.mobileOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
    this.mobileOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CategoryNavigation();
});